import React from "react";
import { observer } from "mobx-react-lite";
import { Tooltip } from "antd";
import { Hooks } from "@xt/xtbase";
const { useTranslation } = Hooks;
import store from "store";

import XtSvg from "components/xt/svg";

import styles from "./index.module.scss";

const Main: React.FC = () => {
  const t = useTranslation();
  const { name, tips } = store.market;
  const marketTip = tips[name];

  if (!marketTip || ![1, 3].includes(marketTip.tipsType)) return <></>;

  return (
    <Tooltip
      placement="bottom"
      title={
        <div className={styles.content}>
          <span>{marketTip.content}</span>
          {!!marketTip.link && (
            <a href={marketTip.link} target="_blank" rel="noreferrer">
              {" " + t("trade.diveDeeper")}
            </a>
          )}
        </div>
      }
    >
      <div className={styles.target}>
        <XtSvg icon={"alert"} />
      </div>
    </Tooltip>
  );
};

export default observer(Main);
